export default [
  {
    path: '/admin/banners',
    name: 'BannerList',
    component: () => import(/* webpackChunkName: "BannerList" */ '../../views/admin/banner/List.vue')
  }
]
